"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _eventBus = require("@/helpers/event-bus.js");

var _dlgNewLineAvenant = _interopRequireDefault(require("./dlgNewLineAvenant"));

var _moment = _interopRequireDefault(require("moment"));

var CONST = _interopRequireWildcard(require("@/helpers/constantes"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = {
  name: 'LotDetailAvenantsTravauxSuppl',
  props: ['idLot'],
  components: {
    dlgNewLineAvenant: _dlgNewLineAvenant.default
  },
  data: function data() {
    return {
      CONST: CONST,
      dlgNewLineVisible: false,
      refresh: 0,
      lotsDetail: [],
      calculs: [],
      totaux: [],
      modeEdit: false
    };
  },
  computed: {
    /* ...mapGetters(['affaire']), */
    affaire: function affaire() {
      return this.$store.getters.affaire;
    },
    maxOrdre: function maxOrdre() {
      var max = 0;

      if (this.lotsDetail.length > 0) {
        max = Math.max.apply(Math, this.$store.getters.affaire.lotsDetail.map(function (x) {
          return x.ordre;
        }));
      }

      return max + 1;
    },
    nbCol: function nbCol() {
      return this.affaire.nbColAvenant;
    }
  },
  created: function created() {
    var _this = this;

    this.$watch('$root.modeEdit', function (newValue) {
      if (newValue === false) {
        _this.modeEdit = false;
      }
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    // this.nbCol = this.getNbCol()
    _eventBus.EventBus.$on('REFRESH', function (params) {
      var typeLigne = [CONST.LOT_DETAIL.TYPE_LIGNE.INITIALE, CONST.LOT_DETAIL.TYPE_LIGNE.AVENANT, CONST.LOT_DETAIL.TYPE_LIGNE.SUPPLEMENTAIRE];
      _this2.lotsDetail = _this2.$store.getters.affaire.lotsDetail.filter(function (x) {
        return x.id_lot === _this2.idLot && typeLigne.includes(x.type_lot_detail);
      });
      _this2.calculs = _this2.$store.getters.affaire.calculs.lotsDetail.filter(function (x) {
        return x.id_lot === _this2.idLot && typeLigne.includes(x.type_lot_detail);
      });
      _this2.totaux = _this2.$store.getters.affaire.calculs.lots.filter(function (x) {
        return x.id === _this2.idLot;
      });
      /*
      if (params) {
        this.nbCol = this.affaire.nbColAvenant
      }
      */
    });

    _eventBus.EventBus.$on('AVENANT_NEW', function () {
      _this2.modeEdit = true;
    });

    _eventBus.EventBus.$on('AVENANT_CANCEL', function () {
      _this2.modeEdit = false;

      _this2.onCancelAvenant();
    });

    _eventBus.EventBus.$on('AVENANT_SAVE', function () {
      _this2.modeEdit = false;

      _this2.onSaveAvenant(); // enregistre les montants et fige la derniere colonne des avenants

    });

    this.refresh++;
  },
  beforeDestroy: function beforeDestroy() {
    _eventBus.EventBus.$off('REFRESH');

    _eventBus.EventBus.$off('AVENANT_NEW');

    _eventBus.EventBus.$off('AVENANT_CANCEL');

    _eventBus.EventBus.$off('AVENANT_SAVE');
  },
  methods: {
    gestMens: function gestMens(numCol) {
      if (this.affaire.calculs.affaire) {
        return this.affaire.calculs.affaire.colonneAvenant[numCol].periode_gestmens;
      }
    },
    dateCol: function dateCol(numCol) {
      if (this.affaire.calculs.affaire) {
        // return this.affaire.calculs.affaire.dateColonneAvenant[numCol]
        return this.affaire.calculs.affaire.colonneAvenant[numCol].date_creation;
      }
    },
    mtTotalLotColonneAvenant: function mtTotalLotColonneAvenant(index, column) {
      return this.totaux[index] && this.totaux[index].mtTotalLotColonneAvenant[column] ? this.totaux[index].mtTotalLotColonneAvenant[column] : '';
    },
    mtTotalLotLigneAvenant: function mtTotalLotLigneAvenant(index) {
      return this.totaux[index] ? this.totaux[index].mtTotalLotLigneAvenant : '';
    },
    canAddAvenant: function canAddAvenant(scope) {
      return scope.row.validation === 1 && scope.row.type_lot_detail === CONST.LOT_DETAIL.TYPE_LIGNE.INITIALE || scope.row.validation === 1 && scope.row.type_lot_detail === CONST.LOT_DETAIL.TYPE_LIGNE.SUPPLEMENTAIRE || scope.row.type_lot_detail === CONST.LOT_DETAIL.TYPE_LIGNE.AVENANT;
    },
    handleInput: function () {
      var _handleInput = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(scope, action) {
        var data;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = {
                  id_lot_detail: scope.row.id,
                  num_colonne: this.nbCol + 1,
                  mt_avenant: scope.row.mt_avenant,
                  date_creation: (0, _moment.default)().format('YYYY-MM-DD HH:mm:ss'),
                  periode_gestmens: this.affaire.YYYYMM ? this.affaire.YYYYMM : ''
                };
                _context.next = 3;
                return this.$store.dispatch('affaire/setAvenant', data);

              case 3:
                if (action === 'refresh_calcul') {
                  _eventBus.EventBus.$emit('REFRESH_CALCULS');
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleInput(_x, _x2) {
        return _handleInput.apply(this, arguments);
      }

      return handleInput;
    }(),
    onCancelAvenant: function () {
      var _onCancelAvenant = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // pour vider le champ de saisie et ne pas avoir l'ancienne valeur quand on fera "Nouvelle avenant"
                this.lotsDetail.forEach(function (row) {
                  if (row.mt_avenant) {
                    row.mt_avenant = '';
                  }
                });
                _context2.next = 3;
                return this.$store.commit('affaire/DEL_ALLAVENANT_BY_NUMCOL', this.nbCol + 1);

              case 3:
                _eventBus.EventBus.$emit('REFRESH_CALCULS');

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onCancelAvenant() {
        return _onCancelAvenant.apply(this, arguments);
      }

      return onCancelAvenant;
    }(),
    onSaveAvenant: function onSaveAvenant() {
      var _this3 = this;

      this.lotsDetail.forEach( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee3(row) {
          var mt, data;
          return _regenerator.default.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  mt = row.mt_avenant || '';

                  if (!(mt !== '')) {
                    _context3.next = 6;
                    break;
                  }

                  data = {
                    id_lot_detail: row.id,
                    num_colonne: _this3.nbCol + 1,
                    mt_avenant: row.mt_avenant,
                    date_creation: (0, _moment.default)().format('YYYY-MM-DD HH:mm:ss'),
                    periode_gestmens: _this3.affaire.YYYYMM ? _this3.affaire.YYYYMM : ''
                  };
                  _context3.next = 5;
                  return _this3.$store.dispatch('affaire/insertAvenant', data);

                case 5:
                  row.mt_avenant = ''; // pour vider le champ de saisie du montant

                case 6:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x3) {
          return _ref.apply(this, arguments);
        };
      }()); // this.nbCol = this.getNbCol()

      this.$root.modeEdit = false;

      _eventBus.EventBus.$emit('REFRESH_CALCULS');
    },
    renderHeader: function renderHeader(h, _ref2) {
      var column = _ref2.column,
          $index = _ref2.$index;
      var label = column.label.split('\\n');
      return h('div', {}, [h('span', label[0]), h('br'), h('span', label[1])]);
    }
  }
};
exports.default = _default;